// extracted by mini-css-extract-plugin
export var basecolor = "#00cc6d";
export var basecolorblack = "#11111f";
export var basecolorblue = "#0181eb";
export var basecolorbright = "#00eb7f";
export var basecolordarkblue = "#0062b3";
export var basecolordarkgreen = "#00994f";
export var basecolordarkpurple = "#751584";
export var basecolorgreen = "#00cc6d";
export var basecolorpink = "#db00ff";
export var basecolorpurple = "#9d1cb2";
export var black = "button-module--black--2ed5e";
export var blue = "button-module--blue--6d0ae";
export var button = "button-module--button--9cda4";
export var color = "white";
export var currentText = "button-module--current-text--c7515";
export var darkblue = "button-module--darkblue--2f7e2";
export var darkgreen = "button-module--darkgreen--7e023";
export var darkpurple = "button-module--darkpurple--144ad";
export var green = "button-module--green--fade9";
export var highlightcolor = "white";
export var inversecolor = "white";
export var pagination = "button-module--pagination--2cc57";
export var pink = "button-module--pink--703fe";
export var pixelated = "button-module--pixelated--f9f37";
export var pixelatedbase = "#008fff";
export var pixelatedbase_old = "#2e9cff";
export var pixelatedhighlight = "#00cc6d";
export var purple = "button-module--purple--c1cf6";
export var vscodevim = "button-module--vscodevim--3ee48";
export var vscodevimblue = "#46a6ff";